var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{staticClass:"pa-4 d-flex justify-space-between align-center"},[_c('div',[_c('Breadcrumbs',{attrs:{"headline":"Quản lý quỹ xu","link":[
            {
              text: 'Quỹ xu',
              href: '../balance'
            }
          ]}})],1)])]),_c('v-card',{staticClass:"pa-6 mx-4 mb-6 elevation-0",attrs:{"outlined":""}},[_c('StudentFilter',{ref:"student-filter",on:{"onFilterChanged":_vm.filterStudent}})],1),_c('div',{staticClass:"mx-4"},[_c('CreditTable')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }